import { IState } from '../../store';

export const selectProfitbaseUrl = (state: IState): string => {
  return state.newbuildingBooking.profitbaseUrl;
};
